module.exports = __webpack_public_path__ + "img/5.927e1bf0.jpg";